export default __webpack_public_path__ + "media/images/airt_page_de_garde_1-f46a5de218206a4385db4a0dac5d650f.png";